import type { Components, Theme } from "@mui/material/styles";
import { DROPDOWN_SURFACE } from "../dropdownSurface";

export const MuiSelect: Components<Theme>["MuiSelect"] = {
  defaultProps: {
    // Applies the dark-mode border to every <Select> dropdown that doesn't pass its
    // own MenuProps. Selects supplying MenuProps fully replace this default (MUI
    // resolveProps shallow-fills MenuProps), so those are patched at the call site.
    MenuProps: {
      slotProps: { paper: { sx: DROPDOWN_SURFACE } },
    },
  },
};
